/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type OnInit, Component, Injector, Input } from '@angular/core';
import { Validators } from '@angular/forms';
import { type Command, DMValidators, FormControl, FormGroup, FormSlideWindowAbstract } from '@dm/core';
import { ToolService } from 'app/common/services';
import { type CIFSShare, type IpWhiteList } from 'app/common/types/mo';
import { SWITCH } from 'app/config/switch';

import { IpWhiteListService } from '../ip-white-list.service';
import { IpWhiteListStrService } from '../ip-white-list-str.service';

@Component({
    selector: 'app-add-ip-white-list',
    templateUrl: './add-ip-white-list.component.html',
    styleUrls: ['./add-ip-white-list.component.scss'],
})
export class AddIpWhiteListComponent extends FormSlideWindowAbstract implements OnInit {
    @Input() cifsData: CIFSShare;
    i18n = this.str.i18n;

    /** 侧滑框标题 */
    title = this.i18n.addIpWhiteListTitle;
    loading = false;
    vm: FormGroup;
    errorMessage: { [key: string]: { [key: string]: string } };
    /** CIFS已有的IP白名单规则 */
    ipList = [];
    SWITCH = SWITCH;

    constructor(
        injector: Injector,
        private str: IpWhiteListStrService,
        private toolService: ToolService,
        private service: IpWhiteListService,
    ) {
        super(injector);
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.service.getExistIps(this.cifsData.ID, this.cifsData.vstoreId, this.ipList);

        this.windowVisible = true;
        this.pageReady = true;
    }

    initVm(): void {
        this.vm = new FormGroup({
            rules: new FormControl([], {
                validators: [
                    Validators.required,
                    DMValidators.multiInputValidator(true, [
                        this.service.rulesValidator,
                        this.service.rulesRepeatValidator(this.ipList),
                    ]),
                ],
            }),
        }, { updateOn: 'blur' });

        this.errorMessage = {
            rules: {
                required: this.toolService.requiredErr(this.i18n.rules),
                ipFormatErr: this.i18n.ipFormatErr,
                ipTypeErr: this.i18n.ipTypeErr,
                ipRepeatErr: this.i18n.ipRepeatErr,
                ipRangeErr: this.i18n.ipRangeErr,
            },
        };
    }

    buildCmds(): Command[] {
        const cmds = [];
        const rules = this.vm.value.rules;
        rules.forEach((item) => {
            const params: IpWhiteList = {
                cifsShareID: this.cifsData.ID,
                rule: item,
                vstoreId: this.cifsData.vstoreId,
            };

            cmds.push({
                name: this.i18n.addIpWhiteListAction(params.rule),
                action: this.service.addIpWhiteList(params),
            });
        });

        return cmds;
    }
}
